import { z } from "zod";
export const QueueResilienceEvidenceV1Schema = z
    .object({
    schemaVersion: z.literal("queue-resilience-evidence.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalQueueResilienceEvidence(recordedAt) {
    return QueueResilienceEvidenceV1Schema.parse({
        schemaVersion: "queue-resilience-evidence.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=queue-resilience-evidence.js.map